import {TagSchema} from 'constants/RegistryConstants';
import {readFragmentFromCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {graphQLToREST} from 'graphql-client/declarative-translations/external/translate';

import {TagSchemaListingWithFieldsGraphQL} from '../../../graphql-fragments/schemas/__generated/TagSchemaListingWithFieldsGraphQL';

export default function getTagSchemaFromCache(
  schemaId?: string | null
): TagSchemaListingWithFieldsGraphQL | null {
  if (schemaId == null) {
    return null;
  } else {
    return readFragmentFromCache(getFragmentWrapper('TagSchemaListingWithFields'), schemaId);
  }
}

/**
 * Get TagSchemaGraphQL from cache and use declarative translations to return the REST shaped TagSchema
 */
export function getTranslatedTagSchemaFromCache(schemaId?: string | null): TagSchema | null {
  if (schemaId == null) {
    return null;
  }
  const cacheResult = readFragmentFromCache(getFragmentWrapper('TagSchema'), schemaId);
  return cacheResult ? graphQLToREST('TagSchema', cacheResult) : null;
}
